/**
 * Noche Speaker Section
 * Scroll-driven storytelling: texto + imagen del hombre cambian,
 * mujer se queda fija. GSAP + ScrollTrigger (ya cargados globalmente).
 */

function initNocheSpeaker() {
  const section = document.querySelector('.noche-speaker');
  if (!section) return;

  const panels = gsap.utils.toArray('.noche-speaker__panel', section);
  const manImages = gsap.utils.toArray('.noche-speaker__man-img', section);

  if (panels.length <= 1) {
    // Con un solo slide, solo mostramos el primero
    if (panels[0]) gsap.set(panels[0], { opacity: 1, y: 0 });
    if (manImages[0]) gsap.set(manImages[0], { opacity: 1 });
    return;
  }

  const totalSlides = panels.length;

  // La sección ocupa N × 100svh para crear el espacio de scroll
  // svh = small viewport height, estable en mobile (no cambia con URL bar)
  var useSvh = CSS.supports && CSS.supports('height', '100svh');
  var unit = useSvh ? 'svh' : 'vh';
  section.style.height = (totalSlides * 100) + unit;

  // Estado inicial: primer panel e imagen visibles
  gsap.set(panels[0], { opacity: 1, y: 0 });
  if (manImages[0]) gsap.set(manImages[0], { opacity: 1 });

  panels.slice(1).forEach((p) => gsap.set(p, { opacity: 0, y: 30 }));
  manImages.slice(1).forEach((img) => gsap.set(img, { opacity: 0 }));

  // Timeline de transiciones
  const tl = gsap.timeline();

  panels.forEach((panel, i) => {
    if (i >= totalSlides - 1) return;

    const nextPanel = panels[i + 1];
    const currentMan = manImages[i];
    const nextMan = manImages[i + 1];

    // Posición en la timeline: cada transición ocupa 1 unidad
    const pos = i;

    // Salida del panel actual
    tl.to(panel, { opacity: 0, y: -30, duration: 0.35, ease: 'power2.in' }, pos);
    if (currentMan) {
      tl.to(currentMan, { opacity: 0, duration: 0.35, ease: 'power2.in' }, pos);
    }

    // Entrada del siguiente panel
    tl.to(nextPanel, { opacity: 1, y: 0, duration: 0.35, ease: 'power2.out' }, pos + 0.65);
    if (nextMan) {
      tl.to(nextMan, { opacity: 1, duration: 0.35, ease: 'power2.out' }, pos + 0.65);
    }
  });

  // ScrollTrigger: sin pin (CSS sticky lo maneja), solo anima el timeline
  gsap.registerPlugin(ScrollTrigger);

  // Ignorar cambios de altura por URL bar en mobile
  ScrollTrigger.config({ ignoreMobileResize: true });

  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    animation: tl,
    invalidateOnRefresh: true,
  });
}

// Inicializar
function runInit() {
  // Limpiar instancias anteriores si el section se recarga en el editor
  ScrollTrigger.getAll()
    .filter((st) => st.vars.trigger && st.vars.trigger.classList?.contains('noche-speaker'))
    .forEach((st) => st.kill());

  initNocheSpeaker();

  // Después de init, si hay hash en URL, re-scroll al target
  // porque section.style.height cambió y desplazó todo
  if (window.location.hash) {
    var target = document.querySelector(window.location.hash);
    if (target) {
      // Esperar a que ScrollTrigger termine de calcular
      ScrollTrigger.refresh();
      requestAnimationFrame(function() {
        target.scrollIntoView({ behavior: 'instant' });
        // Refresh otra vez con posición correcta
        ScrollTrigger.refresh();
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInit);
} else {
  runInit();
}

// Reinicializar en el editor de Shopify
document.addEventListener('shopify:section:load', (e) => {
  if (e.detail.sectionId && document.querySelector('.noche-speaker')) {
    runInit();
  }
});

// Reinicializar solo cuando ANCHO cambia (no cuando URL bar se esconde/muestra)
var lastWidth = window.innerWidth;
window.addEventListener('resize', function() {
  if (window.innerWidth !== lastWidth) {
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runInit, 300);
  }
});
var resizeTimer;
